import React, { FC, HTMLAttributes } from "react";
import { imagePath } from "./image/util";

const HeroArea: FC<HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  return (
    <div {...props}>
      <picture>
        <source media="(max-width: 960px)" srcSet={imagePath("/hero/hero-sp.png")} />
        <img src={imagePath("/hero/hero-pc.png")} alt="アニメふるさと納税" width="100%" decoding="async" />
      </picture>
    </div>
  );
};
export default HeroArea;
